var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout"},[_c('header',[_vm._t("app-header")],2),_c('main',[_c('section',[_vm._t("default")],2),_c('footer',[_vm._t("app-footer")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }